import { matchPath } from 'react-router-dom';

const PUBLIC_SURFACE_PATHS = [
  '/login',
  '/bookings/:bookingWidgetId',
  '/bookings/:bookingWidgetId/:reservationId',
  '/catalogues/:someCatalogueId',
  '/catalogues/:someCatalogueId/:itemId',
  '/store/:storeLink',
  '/store/:storeLink/:dressId',
  '/drops/track/:trackingId',
  '/drops/:contractLinkId',
];

export function isCrispPublicSurface(pathname: string): boolean {
  return PUBLIC_SURFACE_PATHS.some((pattern) =>
    Boolean(matchPath({ path: pattern, end: true }, pathname))
  );
}
